var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillsFilterDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02762 7.51562L9.91137 12.4891C9.92127 12.5477 9.91305 12.6079 9.88781 12.6616C9.86258 12.7154 9.82153 12.7602 9.77016 12.79C9.71879 12.8198 9.65954 12.8332 9.60034 12.8285C9.54113 12.8237 9.4848 12.8009 9.43887 12.7633L7.35053 11.1959C7.24972 11.1206 7.12725 11.0799 7.00141 11.0799C6.87557 11.0799 6.7531 11.1206 6.65228 11.1959L4.56045 12.7627C4.51455 12.8003 4.45829 12.823 4.39916 12.8278C4.34002 12.8326 4.28084 12.8192 4.2295 12.7895C4.17816 12.7597 4.13711 12.7151 4.11182 12.6614C4.08653 12.6077 4.0782 12.5476 4.08795 12.4891L4.97112 7.51562",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.67188C10.5 6.60487 8.933 8.17188 7 8.17188C5.067 8.17188 3.5 6.60487 3.5 4.67188C3.5 2.73888 5.067 1.17188 7 1.17188C8.933 1.17188 10.5 2.73888 10.5 4.67188Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsFilterDark);
export default __webpack_public_path__ + "static/media/skills-filter-dark.1b25f2e117d4609b4b08b1e30b622f27.svg";
export { ForwardRef as ReactComponent };